import { Paper, Slider, Table, Text } from "@mantine/core";
import { OtPosition } from "./PositionStats";
import { getEngineLevelForPosition, getOpponentLevelToDisplay } from "./utils";

interface Props {
    opening: OtPosition;
    movingAverageWindow: number;
    setMovingAverageWindow: (value: number) => void;
}

const PaperBlocks2: React.FC<Props> = ({ opening, movingAverageWindow, setMovingAverageWindow }) => {
    // get data for table
    const ranges: Record<string, any> = {};
    opening.OtAttempt2.forEach((attempt) => {
        const rating = attempt.positionRating;
        const opponentLevel = getEngineLevelForPosition(parseInt(rating as string));
        const ratingRange: string = getOpponentLevelToDisplay(opponentLevel);

        if (!ranges[ratingRange]) {
            ranges[ratingRange] = {
                numGames: 0,
                totalEval: 0,
            };
        }

        ranges[ratingRange].numGames += 1;
        ranges[ratingRange].totalEval += parseFloat(attempt.evaluation);
    });

    ranges["All"] = {
        numGames: opening.OtAttempt2.length,
        totalEval: opening.OtAttempt2.reduce((acc, attempt) => acc + parseFloat(attempt.evaluation), 0),
    };

    return (
        <div className="space-y-8">
            <div>
                <Text c="dimmed" fz="xs" mb="xs">
                    Moving average window
                </Text>
                <Slider
                    value={movingAverageWindow}
                    onChange={setMovingAverageWindow}
                    step={1}
                    min={2}
                    max={Math.min(opening.OtAttempt2.length - 1, 40)}
                />
            </div>
            <Paper p="md" withBorder radius="md" w="320px">
                <Table verticalSpacing="lg">
                    <Table.Thead>
                        <Table.Tr>
                            <Table.Th>Opponent</Table.Th>
                            <Table.Th>Games</Table.Th>
                            <Table.Th>Average eval</Table.Th>
                        </Table.Tr>
                    </Table.Thead>
                    <Table.Tbody>
                        {Object.keys(ranges)
                            .sort()
                            .map((range) => {
                                const numGames = ranges[range].numGames;
                                const averageEval = ranges[range].totalEval / numGames;
                                return (
                                    <Table.Tr key={range}>
                                        <Table.Td ta="left">{range}</Table.Td>
                                        <Table.Td ta="right">{numGames}</Table.Td>
                                        <Table.Td ta="right">{averageEval.toFixed(1)}</Table.Td>
                                    </Table.Tr>
                                );
                            })}
                    </Table.Tbody>
                </Table>
            </Paper>
        </div>
    );
};

export default PaperBlocks2;
